export default "__VITE_PUBLIC_ASSET__f0378fc8__"